import { Form, Formik, FormikHelpers } from 'formik'
import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { Spinner } from 'react-bootstrap'
import {
  useLazyGetOptOutFraudKeywordsQuery,
  useUpdateOptOutFraudKeywordsMutation,
} from '../../../../../services/cellcast'
import { toast } from 'react-toastify'
import { KTSVG } from '../../../../../_metronic/helpers'

type FraudKeyword = {
  keywords: string
}

const validationSchema = Yup.object({
  keywords: Yup.string(),
})

const OptOutFraudKeyword: FC = () => {
  const [initialValue, setInitialValue] = useState<FraudKeyword>({
    keywords: '',
  })

  const [update, { isLoading }] = useUpdateOptOutFraudKeywordsMutation()
  const [fetchFraudKeywords, { data }] = useLazyGetOptOutFraudKeywordsQuery()

  useEffect(() => {
    fetchFraudKeywords(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = (
    values: FraudKeyword,
    formikHelpers: FormikHelpers<FraudKeyword>
  ) => {
    update(values)
      .then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else {
            toast.success(res?.data?.message)
            fetchFraudKeywords(null)
          }
        } else if ('error' in res) {
          const resError = res.error as any
          if (resError.data?.message) {
            toast.error(resError.data?.message || '')
          } else {
            toast.error(res?.error.toString() || '')
          }
        }
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  useEffect(() => {
    if (data?.data) {
      setInitialValue({
        keywords: data?.data?.fraud_keywords as string
      })
    }
  }, [data?.data])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_opt_out_keywords'
      >
        <div className='card-title'>
          <h3 className='fs-2'>Opt-Out Fraud Keywords</h3>
        </div>
      </div>
      <div className='card-body' id='kt_opt_out_keywords'>
        <Formik
          enableReinitialize
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className='first-row'>
                <div className='row'>
                  <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-8'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-primary me-4'
                    />
                    <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                      <div className='mb-3 mb-md-0 fw-bold'>
                        <div className='fs-6 text-gray-600 pe-7'>
                          When a contact sends a message containing your custom opt-out keyword, they will be automatically unsubscribed and no longer receive SMS messages. 
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-12'>
                    <h5 className='text-gray-600 mb-5'>Configure Opt-Out Fraud Keywords</h5>
                    <textarea
                      placeholder={'input your fraud keywords'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      value={values.keywords}
                      rows={10}
                      onChange={(e) => setFieldValue('keywords', e.currentTarget.value)}
                    />
                  </div>
                </div>

              </div>

              <div className='row border-top mt-2 p-4'>
                <div className='col-md-12 text-center text-xl-end text-lg-end text-md-end'>
                  <button
                    data-testid='btn-sound-notification'
                    className='btn btn-sm btn-primary'
                    type='submit'
                  >
                    {isLoading ? <Spinner /> : 'Save Changes'}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default OptOutFraudKeyword
